import {
  MaintenanceMessageTypes,
  MaintenanceMessageState,
  SET_MAINTENANCE_MESSAGE,
} from './MaintenanceMessage.types';

const defaultState = {
  message: null,
  lastUpdated: null,
};

export function maintenanceMessageReducer(
  state = defaultState,
  action: MaintenanceMessageTypes,
): MaintenanceMessageState {
  switch (action.type) {
    case SET_MAINTENANCE_MESSAGE: {
      return {
        ...state,
        message: action.message,
        lastUpdated: Date.now(),
      };
    }
    default:
      return state;
  }
}
